:host {
  display: block;
  --company-logo-size: var(--sl-company-logo-size, 2.125rem);
  --company-logo-size--small: var(--sl-company-logo-size--small, 1.25rem);
  --company-logo-size--medium: var(--sl-company-logo-size--medium, 2.125rem);
  --company-logo-size--large: var(--sl-company-logo-size--large, 3rem);
  --company-logo-size--extra-large: var(--sl-company-logo-size--extra-large, 3.75rem);
}

.sportsline-company-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--company-logo-size, 2.125rem);
}

.sportsline-company-logo--small {
  height: var(--company-logo-size--small, 1.25rem);
}

.sportsline-company-logo--medium {
  height: var(--company-logo-size--medium, 2.125rem);
}

.sportsline-company-logo--large {
  height: var(--company-logo-size--large, 3rem);
}

.sportsline-company-logo--extra-large {
  height: var(--company-logo-size--extra-large, 3.75rem);
}
